import React, { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import LazyRoutes from '../LazyRoutes'
import Loading from 'src/Components/shared/Loading/LoadingApp'

const enabled = process.env.REACT_APP_STYLEGUIDE === 'enabled'

const Styleguide = ({ match }) => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route
        path={match.url}
        component={enabled ? LazyRoutes.Styleguide : () => <Redirect to='/' />}
      />
    </Switch>
  </Suspense>
)

export default Styleguide
